/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Period_InvertedInputs */

const en_us2_workout_period_inverted = /** @type {(inputs: Workout_Period_InvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That period ends before it starts. Pick the dates again.`)
};

const pt_br2_workout_period_inverted = /** @type {(inputs: Workout_Period_InvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse período termina antes de começar. Escolha as datas de novo.`)
};

const es_419_workout_period_inverted = /** @type {(inputs: Workout_Period_InvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese periodo termina antes de empezar. Elige las fechas de nuevo.`)
};

const pt_pt2_workout_period_inverted = /** @type {(inputs: Workout_Period_InvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse período termina antes de começar. Escolhe as datas de novo.`)
};

const fr_fr2_workout_period_inverted = /** @type {(inputs: Workout_Period_InvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette période se termine avant de commencer. Choisis de nouveau les dates.`)
};

const de_de2_workout_period_inverted = /** @type {(inputs: Workout_Period_InvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Zeitraum endet, bevor er beginnt. Wähle die Daten erneut.`)
};

const it_it2_workout_period_inverted = /** @type {(inputs: Workout_Period_InvertedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questo periodo finisce prima di iniziare. Scegli di nuovo le date.`)
};

/**
* | output |
* | --- |
* | "That period ends before it starts. Pick the dates again." |
*
* @param {Workout_Period_InvertedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_period_inverted = /** @type {((inputs?: Workout_Period_InvertedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Period_InvertedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_period_inverted(inputs)
	if (locale === "es-419") return es_419_workout_period_inverted(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_period_inverted(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_period_inverted(inputs)
	if (locale === "de-DE") return de_de2_workout_period_inverted(inputs)
	if (locale === "it-IT") return it_it2_workout_period_inverted(inputs)
	return en_us2_workout_period_inverted(inputs)
});
export { workout_period_inverted as "workout.period_inverted" }